import React from "react";
import { IconButton, Tooltip, Box } from "@mui/material";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useTranslation } from "react-i18next";

const FavoriteButton = ({ onClick, favorited }) => {
  const { t } = useTranslation();

  //* Estilo do ícone do botão (coração)
  const iconStyle = {
    fontSize: 40,
    color: "#522474",
    cursor: "pointer",
    bgcolor: "#E6E6E6",
    borderRadius: "50%",
    padding: "4px",
  };

  return (
    <Box position="relative" display="inline-block">
      <Tooltip
        data-testid="modalInfoActivities_favorite_btn" 
        title={
          favorited
            ? t("newActivities.remove_from_favorites")
            : t("newActivities.save_to_favorites")
        }
      >
        <IconButton onClick={onClick}>
          {/* Se a atividade for favoritada, exibe o ícone de favorito cheio, caso contrário, exibe o ícone de favorito vazio */}
          {favorited ? (
            <FavoriteIcon data-testid="modalInfoActivities_removeFavorite_icon" sx={iconStyle} />
          ) : (
            <FavoriteBorderIcon data-testid="modalInfoActivities_addFavorite_icon" sx={iconStyle} />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default FavoriteButton;
